import {ListToolbar} from './ListToolbar'
import {formatMonthYear} from '../../../../../utils/dayJs/format'
import {useForm} from '../core/FormProvider'

const Header = () => {
  const {filterDates} = useForm()

  function isEmpty(obj: object): boolean {
    return Object.keys(obj).length === 0
  }

  const filterDatesIsEmpty = filterDates ? isEmpty(filterDates) : true

  return (
    <>
      <div className='card-header border-0 pt-6'>
        <div className='card-title'></div>
        <div className='card-toolbar'>{<ListToolbar />}</div>
      </div>
      {!filterDatesIsEmpty && filterDates && (
        <div className='card-header border-0'>
          <div className='card-title'></div>
          <div className='card-toolbar me-3'>
            {formatMonthYear(`${filterDates.year}-${filterDates.month}-${filterDates.day}`)}
          </div>
        </div>
      )}
    </>
  )
}

export {Header}
